export default function () {
  const DEFAULT_POSITION = 50;

  const container = document.querySelector(".js-compareProductImageBlock__container");
  const input = document.querySelector(".js-compareProductImageBlock__input");
  const dragger = document.querySelector(".js-compareProductImageBlock__dragger");
  const containerImageFront = document.querySelector(".js-compareProductImageBlock__containerImageFront");

  if (!container || !input || !dragger || !containerImageFront) return;

  const imageFront = containerImageFront.querySelector("img");

  const updatePosition = (value) => {
    dragger.style.left = `${value}%`;
    containerImageFront.style.width = `${value}%`;
  };

  const updateWidth = () => {
    imageFront.style.width = `${container.clientWidth}px`;
  };

  input.addEventListener("input", (e) => {
    updatePosition(e.target.value);
  });

  window.addEventListener("resize", (e) => {
    imageFront.style.width = `${container.clientWidth}px`;
  });

  // Position initiale
  updateWidth();
  updatePosition(DEFAULT_POSITION);
  
}
